import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-cream text-forest-950" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mjpyb4i388ps" />
      <main data-id="element-2" data-mp="3mj6lg27aoaim">
        <Hero data-id="element-3" data-mp="3rcj6k2crlz6m" />
        <SocialProof data-id="element-4" data-mp="3rbzn2h7gv2qh" />
        <Testimonials data-id="element-5" data-mp="3rdkgg3i1ofmr" />
        <ProblemSection data-id="element-6" data-mp="3rd17vdeab3le" />
        <SystemSection data-id="element-7" data-mp="5yhupa6n3cr" />
        <ModulesSection data-id="element-8" data-mp="67yhm9c7y5s" />
        <BonusSection data-id="element-9" data-mp="4n7u7q58zd7" />
        <UrgencySection data-id="element-10" data-mp="82k72sfnuax" />
        <PricingSection data-id="element-11" data-mp="2zld0z6e9z99y" />
        <MoreResults data-id="element-12" data-mp="2zlv3gkrj6jqb" />
        <GuaranteeSection data-id="element-13" data-mp="2zmo3z3zwcd00" />
        <FAQ data-id="element-14" data-mp="2zng14j956ise" />
        <ClosingSection data-id="element-15" data-mp="33mowfsjtyoq2" />
        <SummaryTable data-id="element-16" data-mp="33lwzadal4ixo" />
        <FinalCta data-id="element-17" data-mp="33ngiabnml835" />
      </main>
      <Footer data-id="element-18" data-mp="33oi2b5mmd4x0" />
      <PurchaseNotification data-id="element-19" data-mp="38lrs4mdx7ild" />
    </div>;
}